import TransferSenderSelect from "./transferSenderSelect.container";

export default TransferSenderSelect;
